import { useEffect } from "react";
import {
  FieldError,
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

import { Toast } from "@covertree/utils";
import { flattenDeep, isNil } from "lodash";

export const useFormWithNotification = <
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object,
>(
  props?: UseFormProps<TFieldValues, TContext>
): UseFormReturn<TFieldValues, TContext> => {
  const form = useForm<TFieldValues, TContext>(props);

  const {
    formState: { errors, isSubmitted },
  } = form;

  useEffect(() => {
    const errorValues = Object.values(errors);

    if (isSubmitted && errorValues.length > 0) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const flattenedErrors = flattenDeep(errorValues).filter(
        (el) => !isNil(el)
      ) as FieldError[];

      const firstError = flattenedErrors[0];

      const errorMessage =
        "message" in firstError
          ? firstError.message
          : Object.values<FieldError>(firstError as never)[0]?.message;

      Toast.showError(errorMessage);
    }
  }, [errors, isSubmitted]);

  return form;
};
